import React from 'react';

const Privacy = () => {
	return (
		<>
			<title>Privacy Policy - FlickScout.com</title>
			<meta name="description" content="Privacy policy for FlickScout - the AI-powered movie recommendation platform." />
			
			<div className="container mx-auto px-4 py-12">
				<div className="max-w-4xl mx-auto">
					<h1 className="text-4xl font-bold mb-8 text-center">Privacy Policy</h1>
					
					<div className="bg-gray-800 rounded-lg p-8 mb-8 shadow-lg">
						<p className="text-gray-300 mb-6">
							Last updated: {new Date().toLocaleDateString('en-US', {year: 'numeric', month: 'long', day: 'numeric'})}
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
						<p className="text-gray-300 mb-6">
							At FlickScout, we respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, 
							use, and safeguard your information when you use our website and services.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">2. Information We Collect</h2>
						<p className="text-gray-300 mb-6">
							We collect minimal personal information necessary to provide our services:
						</p>
						<ul className="list-disc pl-6 mb-6 text-gray-300 space-y-2">
							<li>Information you provide when creating an account (if applicable)</li>
							<li>Your movie preferences and search queries</li>
							<li>Usage data through Google Analytics</li>
						</ul>
						
						<h2 className="text-2xl font-semibold mb-4">3. How We Use Your Information</h2>
						<p className="text-gray-300 mb-6">
							We use the information we collect to:
						</p>
						<ul className="list-disc pl-6 mb-6 text-gray-300 space-y-2">
							<li>Provide, maintain, and improve our services</li>
							<li>Personalize your experience and deliver content relevant to your interests</li>
							<li>Analyze how users interact with our platform to improve functionality</li>
							<li>Communicate with you about updates or changes to our services</li>
						</ul>
						
						<h2 className="text-2xl font-semibold mb-4">4. Cookies and Tracking Technologies</h2>
						<p className="text-gray-300 mb-6">
							We use cookies and similar tracking technologies solely for Google Analytics purposes. These cookies help us understand how visitors 
							interact with our website by collecting and reporting information anonymously. We do not use cookies to store personal information 
							about our users.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">5. Data Sharing and Disclosure</h2>
						<p className="text-gray-300 mb-6">
							We do not sell, trade, or otherwise transfer your personal information to outside parties except in the following cases:
						</p>
						<ul className="list-disc pl-6 mb-6 text-gray-300 space-y-2">
							<li>With service providers who assist us in operating our website and providing our services</li>
							<li>When required by law or to protect our rights</li>
							<li>With your consent</li>
						</ul>
						
						<h2 className="text-2xl font-semibold mb-4">6. Data Security</h2>
						<p className="text-gray-300 mb-6">
							We implement appropriate security measures to protect your personal information against unauthorized access, alteration, 
							disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, 
							and we cannot guarantee absolute security.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">7. Your Rights</h2>
						<p className="text-gray-300 mb-6">
							Depending on your location, you may have certain rights regarding your personal information, including:
						</p>
						<ul className="list-disc pl-6 mb-6 text-gray-300 space-y-2">
							<li>The right to access your personal data</li>
							<li>The right to rectify inaccurate personal data</li>
							<li>The right to request deletion of your personal data</li>
							<li>The right to restrict or object to processing of your personal data</li>
							<li>The right to data portability</li>
						</ul>
						
						<h2 className="text-2xl font-semibold mb-4">8. Children's Privacy</h2>
						<p className="text-gray-300 mb-6">
							Our services are not intended for children under 13 years of age. We do not knowingly collect personal information from children 
							under 13. If we learn we have collected personal information from a child under 13, we will delete that information promptly.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">9. Changes to This Privacy Policy</h2>
						<p className="text-gray-300 mb-6">
							We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page 
							and updating the "Last updated" date.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">10. Contact Us</h2>
						<p className="text-gray-300">
							If you have any questions about this Privacy Policy, please contact us.
						</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default Privacy;


